import { cva } from 'class-variance-authority'

export const tableBody = cva(['rounded-b-none'], {
  variants: {
    variantRow: {
      small: 'px-1 py-4',
      medium: 'px-3 py-3',
      large: 'py-4',
      oneSize: 'px-2 py-1',
      size: 'px-1 py-1',
    },
  },
  defaultVariants: {
    variantRow: 'medium',
  },
})
